// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const InsuranceSVG = styled(Icon).attrs({
    viewBox: '0 0 25 25',
})``;

const Insurance = ({ color = navy, ...props }) => (
    <InsuranceSVG data-test="icon-insurance" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill={color}
            d="M25 4H0v16h25V4zm-2 2H2v12h21V6z"
        />
        <path fill={color} d="M4 11h8v2H4z" />
        <path
            fill={color}
            d="M7 8h2v8H7zM14 8h7v2h-7zM14 14h7v2h-7zM14 11h7v2h-7z"
        />
    </InsuranceSVG>
);

export { Insurance as default, Insurance };
